<template>
  <div className="filter">
    <el-date-picker
      v-model="value"
      :readonly="readonly"
      :type="type"
      :value-format="valueFormat"
      :default-time="defaultTime"
      @change="filter"
    />
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'RestListFilterDateRange',

  inject: ['restList'],

  props: {
    prop: {
      required: false
    },

    readonly: {
      type: Boolean,
      default: false
    },

    datePickerProps: {
      type: Object,
      required: false
    },

    defaultValue: {
      required: false
    },

    convertToUtc: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      value: ''
    }
  },

  mounted() {
    if (this.defaultValue) {
      const parts = this.defaultValue.split(',')
      const from = parts[0]
      const to = parts[1]

      if (from) {
        const toOrNow =
          to || moment.tz(this.projectTimezone).format('YYYY-MM-DD HH:mm:ss')

        this.value = [from, toOrNow]
        if (this.convertToUtc) {
          this.filter()
        } else {
          this.restList.filterField(this.prop, this.value.toString())
        }
      }
    }
  },

  computed: {
    type() {
      if (this.datePickerProps.type) {
        return this.datePickerProps.type
      }
    },

    defaultTime() {
      if (this.datePickerProps.defaultTime) {
        return this.datePickerProps.defaultTime
      }
    },

    valueFormat() {
      if (this.datePickerProps.value_format) {
        return this.datePickerProps.value_format
      }
    },

    projectTimezone() {
      if (
        this.$store.state.app.project &&
        this.$store.state.app.project.timezone
      ) {
        return this.$store.state.app.project.timezone
      }
      return 'UTC'
    }
  },

  methods: {
    filter() {
      if (!this.value) {
        this.restList.filterField(this.prop, null)
        return
      }

      if (!Array.isArray(this.value)) {
        this.value = [this.value]
      }

      if (!this.value[0]) {
        this.restList.filterField(this.prop, null)
        return
      }

      if (this.value.length < 2 || !this.value[1]) {
        this.value[1] = moment
          .tz(this.projectTimezone)
          .format('YYYY-MM-DD HH:mm:ss')
      }

      if (this.convertToUtc) {
        // Convert from project timezone to UTC before sending to API
        const fromDateInProjectTz = moment.tz(
          this.value[0],
          this.projectTimezone
        )
        const toDateInProjectTz = moment.tz(this.value[1], this.projectTimezone)

        if (!fromDateInProjectTz.isValid() || !toDateInProjectTz.isValid()) {
          if (this.$message && this.$message.error) {
            this.$message.error('Invalid date format')
          }
          this.restList.filterField(this.prop, null)
          return
        }

        // Format as UTC for the API
        const fromDateUtc = fromDateInProjectTz
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
        const toDateUtc = toDateInProjectTz.utc().format('YYYY-MM-DD HH:mm:ss')

        const value = `${fromDateUtc},${toDateUtc}`
        this.restList.filterField(this.prop, value)
      } else {
        this.restList.filterField(this.prop, this.value.toString())
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListFilterDateRange.vue